import { Pipe, PipeTransform } from '@angular/core';
import {
  BetaRegistrationTokenVaultActions,
  EmailActions,
  OtherEmailActions,
  PublicTokenVaultActions,
  UserEmailTokenVaultActions,
  UserRegistrationConfirmationTokenVaultActions,
  UserTwoFATokenVaultActions,
} from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'emailActionDisplay',
})
export class EmailActionDisplayPipe implements PipeTransform {
  transform(value: EmailActions | string | null | undefined): string {
    if (!value) return '';
    return emailActionDisplayTransform(value);
  }
}

export function emailActionDisplayTransform(value: EmailActions | string): string {
  if (Object.values(UserEmailTokenVaultActions).includes(value as UserEmailTokenVaultActions)) {
    return CoreNiceLabelUtils.emailAction(value as UserEmailTokenVaultActions);
  }
  if (Object.values(PublicTokenVaultActions).includes(value as PublicTokenVaultActions)) {
    return CoreNiceLabelUtils.publicAction(value as PublicTokenVaultActions);
  }
  if (Object.values(UserTwoFATokenVaultActions).includes(value as UserTwoFATokenVaultActions)) {
    return CoreNiceLabelUtils.twoFAAction(value as UserTwoFATokenVaultActions);
  }
  if (Object.values(OtherEmailActions).includes(value as OtherEmailActions)) {
    return CoreNiceLabelUtils.otherEmailAction(value as OtherEmailActions);
  }
  if (
    Object.values(UserRegistrationConfirmationTokenVaultActions).includes(
      value as UserRegistrationConfirmationTokenVaultActions,
    )
  ) {
    return CoreNiceLabelUtils.registrationAction(value as UserRegistrationConfirmationTokenVaultActions);
  }
  if (Object.values(BetaRegistrationTokenVaultActions).includes(value as BetaRegistrationTokenVaultActions)) {
    return CoreNiceLabelUtils.betaRegistrationAction(value as BetaRegistrationTokenVaultActions);
  }

  return value;
}
